import * as React from 'react';

function SvgNotice(props) {
  return (
    <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.119 2.165a2.35 2.35 0 00-4.238 0L1.117 15.469c-.809 1.589.214 3.698 2.119 3.698h13.527c1.906 0 2.927-2.109 2.12-3.698L12.118 2.165zm-2.12 4.502a.833.833 0 01.834.833v4.167a.834.834 0 01-1.667 0V7.5A.833.833 0 0110 6.667zm0 7.083a.833.833 0 01.834.833V15a.834.834 0 01-1.667 0v-.417A.833.833 0 0110 13.75z"
        fill="#F9A600"
      />
    </svg>
  );
}

export default SvgNotice;
